import styled from 'styled-components';

export const EmptyDescriptionWrapper = styled.div`
  border: 1px solid #707070;
  height: 13rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
